import React, { useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { MdModeEdit } from "react-icons/md";
import * as apicall from "../../components/Apicall";
import Loader from "../../components/Loader/Loader";
import { Form } from "react-bootstrap";

function EachRowCell({ item, currentEdit, refreshPage }) {
  const [name, setName] = useState(item?.name);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [commission, setCommission] = useState("");

  async function editNameFunction() {
    try {
      let data = {
        id: item?.id,
        name: name,
        commission:commission
      };
      let api = "editService";
      if (currentEdit === "Profile") {
        api = "editPartner";
      }

      setLoading(true);
      await apicall.post(data, api);
      setEdit(false);
      setLoading(false);
      refreshPage();
    } catch (e) {
      console.log("err---", e);
    }
  }

  const toggleServiceStatus = async () => {
    try {
      await apicall.post(
        {
          id: item.id,
          is_active: item?.is_active === 1 ? 0 : 1,
        },
        "active_status"
      );
      window.location.reload();
    } catch (e) {
      console.log("err---", e);
    }
  };

  return (
<div
  className="d-flex align-items-center"
  style={{ padding: "12px 16px", fontSize: "14px", color: "#374151", borderBottom: "1px solid #F3F4F6", transition: "background 0.15s" }}
  onMouseEnter={e => e.currentTarget.style.background = "#F9FAFB"}
  onMouseLeave={e => e.currentTarget.style.background = "transparent"}
>

  {currentEdit === "Service" ? (
    <>
      {/* Name */}
      <div style={{ width: "50%" }}>
        {!edit ? (
          <div>{item?.name}</div>
        ) : (
          <div className="d-flex align-items-center gap-2">
            <input
              onKeyDown={(e) => e.key === "Enter" && editNameFunction()}
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="form-control"
              style={{ maxWidth: "200px" }}
              autoFocus
            />
            {loading ? (
              <Loader style={{ width: 40, height: 20 }} />
            ) : (
              <FaArrowRight onClick={editNameFunction} />
            )}
          </div>
        )}
      </div>

      {/* Action */}
      <div style={{ width: "40%" }}>
        <MdModeEdit onClick={() => setEdit(!edit)} />
      </div>

      {/* Toggle */}
      <div style={{ width: "30%" }}>
        <Form.Check
          type="switch"
          id={`service-switch-${item.id}`}
          checked={item?.is_active === 1}
          onChange={toggleServiceStatus}
        />
      </div>
    </>
  ) : (
    <>
      {/* Profile Name */}
      <div style={{ width: "40%" }}>
        {!edit ? (
          <div>{item?.partner_name || item?.name}</div>
        ) : (
          <div className="d-flex align-items-center gap-2">
            <input
              onKeyDown={(e) => e.key === "Enter" && editNameFunction()}
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="form-control"
              style={{ maxWidth: "180px" }}
              autoFocus
            />
          </div>
        )}
      </div>

      {/* Commission */}
      <div style={{ width: "30%" }}>
        {!edit ? (
          <div>{item?.commission ? `${item.commission}%` : ""}</div>
        ) : (
          <input
            type="number"
            value={commission}
            onChange={(e) => setCommission(e.target.value)}
            className="form-control"
            style={{ maxWidth: "120px" }}
            placeholder="%"
          />
        )}
      </div>

      {/* Action */}
      <div style={{ width: "30%", textAlign: "right" }}>
        {edit ? (
          loading ? (
            <Loader style={{ width: 40, height: 20 }} />
          ) : (
            <FaArrowRight onClick={editNameFunction} />
          )
        ) : (
          <MdModeEdit onClick={() => setEdit(true)} />
        )}
      </div>
    </>
  )}
</div>
  );
}

export default EachRowCell;